import { render, staticRenderFns } from "./create-user.vue?vue&type=template&id=4c4a780c&scoped=true"
import script from "./create-user.vue?vue&type=script&lang=js"
export * from "./create-user.vue?vue&type=script&lang=js"
import style0 from "./create-user.vue?vue&type=style&index=0&id=4c4a780c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4a780c",
  null
  
)

export default component.exports